import React, { useContext } from "react";
import useStateManager from "./index";

const StateContext = React.createContext(undefined);

export const StateProvider = ({ children }) => {
  const stateHooks = {
    app: useStateManager()
  };
  return (
    <StateContext.Provider value={stateHooks}>
      {children}
    </StateContext.Provider>
  );
};
// curry the Context
export const useStateHooks = () => {
  return useContext(StateContext);
};